import { Box, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import Markdown from 'react-markdown';

import { ConnectApiDoubleOptInPendingConsentDto } from '../../core/api/dtos';
import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { ChannelItems } from './channel-items';
import {
    ButtonWrapper,
    ConfirmationButtonWrapper,
    GreenButton,
    RedButton,
    Title
} from './components';

interface ConfirmationPageProps {
    studioName: string;
    operatingCompanyName: string;
    pendingConsents: ConnectApiDoubleOptInPendingConsentDto[];
    onConfirm: () => void;
    onDecline: () => void;
}

export const ConfirmationPage = observer(
    (props: ConfirmationPageProps): React.ReactElement => {
        const {
            pendingConsents,
            studioName,
            operatingCompanyName,
            onConfirm,
            onDecline
        } = props;

        const { translate } = injectTSDI(I18n);

        return (
            <Box
                display="flex"
                flexGrow={1}
                marginLeft={4}
                marginRight={4}
                marginBottom={4}
                alignItems="center"
                flexDirection="column"
                justifyContent="space-between"
            >
                <Box justifyItems="center" marginTop={14}>
                    <Title align="center" variant="h1">
                        {translate(
                            'comm.center.marketing.consent.confirmation.title'
                        )}
                    </Title>
                    <Box
                        display="flex"
                        maxWidth="700px"
                        alignItems="center"
                        flexDirection="column"
                        marginTop={6}
                    >
                        <Typography component="div">
                            <Markdown components={{ p: 'div' }}>
                                {translate(
                                    'comm.center.marketing.consent.confirmation.message',
                                    studioName
                                )}
                            </Markdown>
                            <ChannelItems pendingConsents={pendingConsents} />
                        </Typography>
                        <ButtonWrapper>
                            <ConfirmationButtonWrapper>
                                <GreenButton onClick={onConfirm}>
                                    {translate(
                                        'comm.center.marketing.consent.confirmation.button.confirm'
                                    )}
                                </GreenButton>
                            </ConfirmationButtonWrapper>
                            <RedButton onClick={onDecline}>
                                {translate(
                                    'comm.center.marketing.consent.confirmation.button.deny'
                                )}
                            </RedButton>
                        </ButtonWrapper>
                    </Box>
                </Box>
                <Box>
                    <Typography>
                        {translate(
                            'comm.center.marketing.consent.confirmation.button.subtitle',
                            operatingCompanyName
                        )}
                    </Typography>
                </Box>
            </Box>
        );
    }
);
